import React, {
  Component,
  useContext,
  useState,
  useRef,
  useEffect,
} from 'react';
import CustomDatePicker from '../component/CustomDatePicker';
import { InputAlert } from '../component/InputAlert';
import Async from 'react-select/async';
import Select from 'react-select';
import './css/form.css';
import { parse } from 'date-fns';

const styles = {
  placeholder: (base) => ({
    ...base,
    fontSize: '14px',
  }),
  option: (base) => ({
    ...base,
    fontSize: '14px',
  }),
  noOptionsMessage: (base) => ({
    ...base,
    fontSize: '14px',
  }),
  clearIndicator: (base) => ({
    ...base,
    display: 'none',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    display: 'none',
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#5e72e4',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#f4f5f7',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#f4f5f7',
    ':hover': {
      backgroundColor: '#f5365c',
    },
  }),
};

const FormContext = React.createContext();

const FormRow = ({ children, style = '' }) => (
  <div className={ `row ${ style }` }> {children} </div>
);

const FormGroupRow = ({ children }) => (
  <div className="form-group row"> {children} </div>
);

const FormColumn = ({ children, lg = 12, xs = 12, style = '' }) => {
  const newLg = lg > 12 ? 12 : lg;
  const newXs = xs > 12 ? 12 : xs;
  return (
    <div className={ `col-lg-${ newLg } col-xs-${ newXs } ${ style }` }>
      {' '}
      {children}{' '}
    </div>
  );
};

const FormTextInput = ({
  customAlert,
  label = '',
  type = 'text',
  labelWidth = 5,
  inputWidth = '',
  marginTop = '',
  offset = '',
  value = '',
  defaultValue = '',
  name = '',
  onChange = () => {},
  conditionalDisabled = false,
  placeholder = '',
  errorMessage = '',
  disabled = false,
  preText = '',
  maxLength = undefined,
}) => {
  const { wasValidated, validationRules } = useContext(FormContext);

  return (
    <div className={ `form-group row ${ marginTop && `mt-${ marginTop }` }` }>
      {label !== '' ? (
        <label
          htmlFor="example-text-input"
          className={ `col-lg-${ labelWidth } ${
            offset && `offset-lg-${ offset }`
          } col-md-12 col-form-label col-form-label-sm form-control-label` }
        >
          {label}
        </label>
      ) : (
        ''
      )}
      <div
        className={ `col-lg-${
          label !== ''
            ? inputWidth
              ? inputWidth
              : 12 - labelWidth
            : inputWidth
              ? inputWidth
              : 12
        } ${ label ? '' : offset && `offset-lg-${ offset } ` } col-md-12` }
      >
        <div className="input-group input-group-sm">
          {preText ? (
            <div className="input-group-prepend">
              <span className="input-group-text">{preText}</span>
            </div>
          ) : (
            ''
          )}
          {defaultValue ? (
            <input
              className="form-control form-control-sm"
              type={ type }
              name={ name }
              value={ value }
              onChange={ onChange }
              disabled={ conditionalDisabled }
              placeholder={ placeholder }
              defaultValue={ defaultValue }
              disabled={ disabled }
              maxLength={ maxLength }
            />
          ) : (
            <input
              className="form-control form-control-sm"
              type={ type }
              name={ name }
              value={ value }
              onChange={ onChange }
              disabled={ conditionalDisabled }
              placeholder={ placeholder }
              disabled={ disabled }
              maxLength={ maxLength }
            />
          )}
        </div>
        {customAlert ? (
          customAlert
        ) : (
          <InputAlert
            validation={
              validationRules.hasOwnProperty(name) && validationRules[ name ]
            }
            wasValidated={ wasValidated }
          />
        )}
      </div>
      <span className="text-sm text-danger">{errorMessage}</span>
    </div>
  );
};

const FormTextAreaInput = ({
  customAlert,
  label = '',
  value = '',
  name = '',
  conditionalDisabled = false,
  onChange = () => {},
}) => {
  const { wasValidated, validationRules } = useContext(FormContext);
  return (
    <div className="form-group row">
      {label !== '' ? (
        <label
          htmlFor="example-text-input"
          className="col-lg-5 col-md-12 col-form-label col-form-label-sm form-control-label"
        >
          {label}
        </label>
      ) : (
        ''
      )}
      <div className={ `col-lg-${ label !== '' ? 7 : 12 } col-md-12` }>
        <textarea
          style={ {
            resize: 'none',
          } }
          className="form-control"
          rows="3"
          name={ name }
          value={ value }
          onChange={ onChange }
          disabled={ conditionalDisabled }
        />
        {customAlert ? (
          customAlert
        ) : (
          <InputAlert
            validation={
              validationRules.hasOwnProperty(name) && validationRules[ name ]
            }
            wasValidated={ wasValidated }
          />
        )}
      </div>
    </div>
  );
};

const FormSelect = ({
  customAlert,
  label = '',
  value = '',
  name = '',
  onChange = '',
  options = [],
  conditionalDisabled = false,
}) => {
  const { wasValidated, validationRules } = useContext(FormContext);
  return (
    <div className="form-group row">
      {label !== '' ? (
        <label
          htmlFor="example-text-input"
          className="col-lg-5 col-md-12 col-form-label col-form-label-sm form-control-label"
        >
          {label}
        </label>
      ) : (
        ''
      )}
      <div className={ `col-lg-${ label !== '' ? 7 : 12 } col-md-12 ` }>
        <select
          className="form-control form-control-sm"
          id="example-text-input"
          name={ name }
          onChange={ onChange }
          disabled={ conditionalDisabled }
          value={ value }
        >
          <option value=""> --Pilih-- </option>
          {options.length
            ? options.map((option, k) => {
              if (option?.child?.length)
                return (
                  <optgroup key={ `${name}-${k}-${option.value}` } label={ option.label }>
                    {option.child.map((childOption) => {
                      return (
                        <option
                          key={ `${name}-${k}-${childOption.clinic_id}` }
                          value={ childOption.clinic_id }
                        >
                          {childOption.name}
                        </option>
                      );
                    })}
                  </optgroup>
                );
              else
                return (
                  <option key={ `${name}-${k}-${option?.value}` } value={ option?.value }>
                    {option?.label}
                  </option>
                );
            })
            : ''}
        </select>
        {customAlert ? (
          customAlert
        ) : (
          <InputAlert
            validation={
              validationRules.hasOwnProperty(name) && validationRules[ name ]
            }
            wasValidated={ wasValidated }
          />
        )}
      </div>
    </div>
  );
};

const FormDatePicker = ({
  customAlert,
  name = '',
  label = '',
  value = '',
  onChange = () => {},
  size = 'md',
  placeholder = '',
  conditionalDisabled = false,
}) => {
  const { wasValidated, validationRules } = useContext(FormContext);

  return (
    <div className="form-group row">
      {label !== '' ? (
        <label
          htmlFor="example-text-input"
          className="col-lg-5 col-md-12  col-form-label col-form-label-sm form-control-label"
        >
          {label}
        </label>
      ) : (
        ''
      )}
      <div className={ `col-lg-${ label !== '' ? 7 : 12 } col-md-12` }>
        <CustomDatePicker
          value={ value }
          onChange={ (e) => onChange(e, name) }
          size={ size }
          placeholder={ placeholder }
          disabled={ conditionalDisabled }
        />
        {customAlert ? (
          customAlert
        ) : (
          <InputAlert
            validation={
              validationRules.hasOwnProperty(name) && validationRules[ name ]
            }
            wasValidated={ wasValidated }
          />
        )}
      </div>
    </div>
  );
};

const FormDatePicker2 = ({
  customAlert,
  name = '',
  label = '',
  value = '',
  onChange = () => {},
  size = 'md',
  placeholder = '',
  conditionalDisabled = false,
}) => {
  const { wasValidated, validationRules } = useContext(FormContext);

  return (
    <div className="form-group row">
      {label !== '' ? (
        <label
          htmlFor="example-text-input"
          className="col-lg-5 col-md-12  col-form-label col-form-label-sm form-control-label"
        >
          {label}
        </label>
      ) : (
        ''
      )}
      <div className={ `col-lg-${ label !== '' ? 7 : 12 } col-md-12` }>
        <CustomDatePicker
          value={ value }
          onChange={ (date) => onChange(name, date) }
          size={ size }
          placeholder={ placeholder }
          disabled={ conditionalDisabled }
        />
        {customAlert ? (
          customAlert
        ) : (
          <InputAlert
            validation={
              validationRules.hasOwnProperty(name) && validationRules[ name ]
            }
            wasValidated={ wasValidated }
          />
        )}
      </div>
    </div>
  );
};

const FormRadio = ({
  customAlert,
  label = '',
  labelWidth = 5,
  name = '',
  value = '',
  onChange = () => {},
  options = [],
}) => {
  const { wasValidated, validationRules } = useContext(FormContext);
  const val = value;
  // console.log(val, name);
  return (
    <div className="form-group row">
      {label !== '' ? (
        <label
          htmlFor="example-text-input"
          className={ `col-lg-${ labelWidth } col-md-12 col-form-label col-form-label-sm form-control-label` }
        >
          {label}
        </label>
      ) : (
        ''
      )}
      <div
        className={ `col-lg-${ label !== '' ? 12 - labelWidth : 12 } col-md-12` }
      >
        {options.length > 0
          ? options.map(({ value, label: radioName }) => {
            return (
              <div
                key={ value }
                className="custom-control custom-radio custom-control-inline"
              >
                <input
                  type="radio"
                  id={ value + label }
                  name={ name }
                  className="custom-control-input"
                  value={ value }
                  onChange={ onChange }
                  checked={ value.toString() === val.toString() ? true : false }
                />
                <label
                  className="custom-control-label"
                  htmlFor={ value + label }
                >
                  {radioName}
                </label>
              </div>
            );
          })
          : ''}
        {customAlert ? (
          customAlert
        ) : (
          <InputAlert
            validation={
              validationRules.hasOwnProperty(name) && validationRules[ name ]
            }
            wasValidated={ wasValidated }
          />
        )}
      </div>
    </div>
  );
};

const FormCheckBox = ({
  customAlert,
  label = '',
  name = '',
  onChange = () => {},
  options = [],
}) => {
  return (
    <div className="form-group row">
      {label !== '' ? (
        <label
          htmlFor="example-text-input"
          className="col-lg-5 col-md-12 col-form-label col-form-label-sm form-control-label"
        >
          {label}
        </label>
      ) : (
        ''
      )}
      <div className={ `col-lg-${ label !== '' ? 7 : 12 } col-md-12` }>
        {options.length > 0
          ? options.map(({ value, label }, i) => {
            const uniqueId = Math.random();
            return (
              <div
                key={ `${ value }-${ label }` }
                className="custom-control custom-checkbox mb-3"
              >
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id={ uniqueId }
                  value={ value }
                  onChange={ (e) => onChange(e, i) }
                  // defaultChecked={ defaultValue ? true : false }
                />
                <label className="custom-control-label" htmlFor={ uniqueId }>
                  {label}
                </label>
              </div>
            );
          })
          : ''}
        {
          customAlert ? customAlert : ''
          // <InputAlert
          //   validation={
          //     validationRules.hasOwnProperty(name) && validationRules[ name ]
          //   }
          //   wasValidated={ wasValidated }
          // />
        }
      </div>
    </div>
  );
};

const FormRadioCustom = ({
  customAlert,
  label = '',
  labelWidth = 5,
  inputWidth = '',
  input = '',
  name = '',
  onChange = () => {},
  options = [],
  errorMessage = '',
  disabled = false,
}) => {
  const [ checked, setChecked ] = useState({});
  const [ checkboxChecked, setCheckboxChecked ] = useState([]);
  const { wasValidated, validationRules } = useContext(FormContext);

  return (
    <div className="form-group row">
      {label !== '' ? (
        <label
          htmlFor="example-text-input"
          className={ `col-lg-${ labelWidth } col-md-12 col-form-label col-form-label-sm form-control-label` }
        >
          {label}
        </label>
      ) : (
        ''
      )}
      <div
        className={ `col-lg-${
          label !== ''
            ? inputWidth
              ? inputWidth
              : 12 - labelWidth
            : inputWidth
              ? inputWidth
              : 12
        } } col-md-12` }
      >
        {options.length > 0
          ? options.map(
            (
              { value, label: labelText, inputType = 'radio', defaultValue },
              i
            ) => {
              return (
                <>
                  <div
                    class={ `custom-control ${
                      inputType !== 'checkbox&text'
                        ? 'custom-radio custom-control-inline'
                        : 'custom-checkbox'
                    } ${ inputType === 'text' ? 'd-none' : '' }` }
                  >
                    {inputType === 'radio' || inputType === 'radio&text' ? (
                      <>
                        <input
                          type="radio"
                          id={ value + label }
                          name={ name }
                          className="custom-control-input"
                          value={ value }
                          onChange={ (e) => {
                            onChange(e);
                            setChecked({
                              [ e.target.value ]: e.target.checked,
                            });
                          } }
                          defaultChecked={ defaultValue ? true : false }
                          disabled={ disabled }
                        />
                        <label
                          className="custom-control-label custom-radio-label"
                          htmlFor={ value + label }
                        >
                          {labelText}
                        </label>
                      </>
                    ) : inputType === 'checkbox&text' ? (
                      <>
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id={ value + label }
                          value={ value }
                          onChange={ (e) => {
                            e.persist();
                            onChange(e, value, e.target.checked);
                            setCheckboxChecked((prevState) => {
                              prevState[ i ] = e.target.checked;
                              return prevState;
                            });
                          } }
                          defaultChecked={ defaultValue ? true : false }
                          disabled={ disabled }
                        />
                        <label
                          className="custom-control-label"
                          htmlFor={ value + label }
                        >
                          {labelText}
                        </label>
                      </>
                    ) : (
                      ''
                    )}
                  </div>
                  {inputType === 'radio&text' || inputType === 'text' ? (
                    <div
                      className={ `col-lg-4 ${
                        inputType === 'text'
                          ? ''
                          : defaultValue
                            ? ''
                            : checked[ value ]
                              ? ''
                              : 'd-none'
                      }` }
                    >
                      {input({
                        data: value,
                        inputType,
                        defaultValue,
                        disabled,
                      })}
                    </div>
                  ) : inputType === 'checkbox&text' ? (
                    <div
                      className={ `col-lg-4 ${
                        defaultValue ? '' : checkboxChecked[ i ] ? '' : 'd-none'
                      }` }
                    >
                      {input({ data: value, inputType, defaultValue })}
                    </div>
                  ) : (
                    ''
                  )}
                  <br />
                </>
              );
            }
          )
          : ''}
        {customAlert ? (
          customAlert
        ) : (
          <InputAlert
            validation={
              validationRules.hasOwnProperty(name) && validationRules[ name ]
            }
            wasValidated={ wasValidated }
          />
        )}
      </div>
      <span className="text-sm text-danger">{errorMessage}</span>
    </div>
  );
};

const FormReactSelect = ({
  label = '',
  customAlert,
  name = '',
  value = '',
  options = [],
  isMulti = false,
  placeholder = '',
  onChange = () => {},
}) => {
  const { wasValidated, validationRules } = useContext(FormContext);
  return (
    <div className="form-group row">
      {label !== '' ? (
        <label
          htmlFor="example-text-input"
          className="col-lg-5 col-md-12 col-form-label col-form-label-sm form-control-label"
        >
          {label}
        </label>
      ) : (
        ''
      )}
      <div className={ `col-lg-${ label !== '' ? 7 : 12 } col-md-12 ` }>
        <Select
          styles={ styles }
          options={ options }
          isMulti={ isMulti }
          placeholder={ placeholder }
          name={ name }
          onChange={ onChange }
          value={ value }
        />
        {customAlert ? (
          customAlert
        ) : (
          <InputAlert
            validation={
              validationRules.hasOwnProperty(name) && validationRules[ name ]
            }
            wasValidated={ wasValidated }
          />
        )}
      </div>
    </div>
  );
};

const FormAsyncSelect = ({
  label = '',
  customAlert,
  name = '',
  placeholder = '',
  onChange = () => {},
  loadOptions = () => {},
  isMulti = false,
  value = ''
}) => {
  const { wasValidated, validationRules } = useContext(FormContext);
  return (
    <div className="form-group row">
      {label !== '' ? (
          <label
              htmlFor="example-text-input"
              className="col-lg-3 col-md-12 col-form-label col-form-label-sm form-control-label"
          >
            {label}
          </label>
      ) : (
          ''
      )}
      <div className={ `col-lg-${ label !== '' ? 9 : 12 } col-md-12 ` }>
        <Async
          styles={ styles }
          cacheOptions
          loadOptions={ loadOptions }
          name={ name }
          onChange={ onChange }
          isMulti={ isMulti }
          placeholder={ placeholder }
          value = {value}
        />
        {customAlert ? (
          customAlert
        ) : (
          <InputAlert
            validation={
              validationRules.hasOwnProperty(name) && validationRules[ name ]
            }
            wasValidated={ wasValidated }
          />
        )}
      </div>
    </div>
  );
};

const FormFileBrowser = ({
  label = '',
  name = '',
  isUploading = false,
  onChange = () => {},
  downloadFile = '',
  validationAlert,
  disabled = false,
  onBlur = () => {},
  fileNameProps = '',
  customAlert,
}) => {
  const { wasValidated, validationRules } = useContext(FormContext);
  const [ fileName, setFileName ] = useState('Select file');
  return (
    <div className="form-group row">
      {label !== '' ? (
        <label
          htmlFor="example-text-input"
          className="col-lg-5 col-md-12 col-form-label col-form-label-sm form-control-label"
        >
          {label}
        </label>
      ) : (
        ''
      )}
      <div className={ `col-lg-${ label !== '' ? 7 : 12 } col-md-12` }>
        <div className="custom-file">
          <input
            type="file"
            name={ name }
            onChange={ (e) => {
              if (!e.target.files[ 0 ]) return '';
              onChange(e);
              setFileName(e.target.files[ 0 ].name);
            } }
            onBlur={ onBlur }
            className="custom-file-input"
            disabled={ disabled }
          />
          <label
            className="custom-file-label col-form-label-sm"
            htmlFor="customFileLang"
            style={ {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            } }
          >
            {fileName}
          </label>
        </div>
        {downloadFile}
        {customAlert ? (
          customAlert
        ) : (
          <InputAlert
            validation={
              validationRules.hasOwnProperty(name) && validationRules[ name ]
            }
            wasValidated={ wasValidated }
          />
        )}
      </div>
    </div>
  );
};

export default class Form extends Component {
  static GroupRow = FormGroupRow;
  static Row = FormRow;
  static Column = FormColumn;
  static TextInput = FormTextInput;
  static TextAreaInput = FormTextAreaInput;
  static DatePicker = FormDatePicker;
  static DatePicker2 = FormDatePicker2;
  static Select = FormSelect;
  static ReactSelect = FormReactSelect;
  static AsyncSelect = FormAsyncSelect;
  static Radio = FormRadio;
  static CheckBox = FormCheckBox;
  static RadioCustom = FormRadioCustom;
  static FileBrowser = FormFileBrowser;

  render() {
    return (
      <FormContext.Provider
        value={ {
          wasValidated: this.props.wasValidated,
          validationRules: this.props.validationRules || [],
        } }
      >
        <div className={ this.props.class }> {this.props.children} </div>
      </FormContext.Provider>
    );
  }
}
